import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {BaseListComponent} from "../base-list/base-list.component";
import {NgIf} from "@angular/common";
import {TemplateComponent} from "../template/template.component";
import {ActivatedRoute, Router} from "@angular/router";
import {CrudService} from "../service/crud.service";
import {BaseEditComponent} from "../base-edit/base-edit.component";
import {EInputType, IEditConfig} from "../../../interface/table.config";
import {ICrudRes} from "../../../interface/http.config";
import {Validators} from "@angular/forms";
import {listFromMap} from "../../../helper/list.helper";

@Component({
  selector: 'app-manager-edit',
  standalone: true,
  imports: [
    BaseListComponent,
    NgIf,
    TemplateComponent,
    BaseEditComponent
  ],
  templateUrl: './manager-edit.component.html',
  styleUrl: './manager-edit.component.scss'
})
export class ManagerEditComponent implements OnInit {
  data: any;
  id: string | null = null;
  roleList: {value: string; label: string}[] = [];
  blockedList: {value: string; label: string}[] = [
    {value: '1', label: 'Yes'},
    {value: '0', label: 'No'},
  ];

  constructor(protected router: Router,
              protected route: ActivatedRoute,
              protected cdr: ChangeDetectorRef,
              protected crudService: CrudService) {

  }

  editLink = '/dashboard/manager-edit/';
  menuLink = '/dashboard/manager';
  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id') || null;

    this.crudService.provider = 'manager';


    this.crudService.getList('manager-role', 'id', 'name').then(data => {
      this.roleList = listFromMap(data);

      this.cdr.detectChanges();
    });

    if (this.editConfig.groups.length && this.id) {

      this.editConfig.groups[0].configs = [
        {
          field: 'id',
          type: EInputType.DISABLED,
          name: 'Id',
          validators: [],
        },
        ...this.editConfig.groups[0].configs
      ];

      this.getItem();
    } else {
      this.data = {} as any;

    }
  }

  editConfig: IEditConfig = {
    groups: [
      {
        name: 'General (New Manager)',
        configs: [
          {field: 'nickname', name: 'Email', type: EInputType.EMAIL, validators: [Validators.required, Validators.email]},
          {field: 'fio', name: 'FIO', type: EInputType.TEXT, validators: []},
          {field: 'jobTitle', name: 'Job Title', type: EInputType.TEXT, validators: []},
          {field: 'managerRoleId', name: 'Role', type: EInputType.SELECT, options: () => this.roleList, validators: [Validators.required]},
          {field: 'blocked', name: 'Blocked', type: EInputType.SELECT, options: () => this.blockedList, validators: [Validators.required]},
          {field: 'comment', name: 'Comment', type: EInputType.TEXTAREA, validators: []},
        ]
      }
    ]
  };

  getItem() {
    this.crudService.item({id: this.id}).then(item => {
      this.data = item;
      this.data.password = '';

      this.editConfig.groups[0].name = 'General (Manager ' + item.nickname + ')';
    }).catch(console.error);
  }

  onAction(actionName: string, item: any) {
    if (actionName === 'submit') {
      this.crudService.save(item).then((data) => {
        if (!item.id) {
          this.router.navigate([this.editLink + '/' + data.document.id]).catch(console.error);
        } else {
          this.getItem();
        }
      });
    }

    if (actionName === 'back') {
      this.router.navigate([this.menuLink]).catch(console.error);
    }
  }
}
